import _ from 'lodash';

const initState = () => ({
  competitionIds: [],
  filters: {},
  filterTeamIds: [],
  selectedRounds: [],
  filterEntities: [],
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    reset: (state) => _.assign(state, initState()),
    // payload: {competitionId: []}
    updateCompetitionIds: (state, payload) => state.competitionIds = payload.competitionId,
    updateFilters: (state, payload) => state.filters = payload.filters,
    updateFilterTeamIds: (state, payload) => state.filterTeamIds = payload.filterTeamIds,
    updateSelectedRounds: (state, payload) => state.selectedRounds = payload.selectedRounds,
    updateFilterEntities: (state, payload) => state.filterEntities = payload.filterEntities,
  },
  actions: {
  },
  getters: {
    competitionIds: (state) => state.competitionIds,
    filters: (state) => state.filters,
    filterTeamIds: (state) => state.filterTeamIds,
    selectedRounds: (state) => state.selectedRounds,
    filterEntities: (state) => state.filterEntities,
  },
};
